export const FILE_STATUS_UPLOADING = 'uploading';
export const FILE_STATUS_UPLOADED = 'uploaded';
export const FILE_STATUS_ERROR = 'error';
export const URL_STATUS_ERROR = 'url_error';